export default "<p>\n  qrscan works!\n</p>\n";